/**
 * @generated SignedSource<<1bb863032cd3434ca621ea4bff53b0b0>>
 * @relayHash 0146c321bb946ad926bc9dcf6a4c09e6
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0146c321bb946ad926bc9dcf6a4c09e6

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Language = "ENGLISH" | "FRENCH" | "GERMAN" | "ITALIAN";
export type MedicalPrescription = "DIAGNOSTIC_NEUROPSYCHOLOGY_FOR_SUSPECTED_BRAIN_DISORDERS" | "PROGRESS_ASSESSMENT";
export type Ch_updateNeuropsychologicDiagnosticPrescriptionInput = {
  email?: string | null;
  healthcareProviderId?: string | null;
  id: string;
  language: Language;
  medicalPrescriptions: ReadonlyArray<MedicalPrescription>;
  name?: string | null;
  phoneNumber?: string | null;
  relationship?: string | null;
};
export type useChUpdateNeuropsychologicDiagnosticPrescriptionMutation$variables = {
  input: Ch_updateNeuropsychologicDiagnosticPrescriptionInput;
};
export type useChUpdateNeuropsychologicDiagnosticPrescriptionMutation$data = {
  readonly ch_updateNeuropsychologicDiagnosticPrescription: {
    readonly ch_NeuropsychologicDiagnosticPrescription: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"chNeuropsychologicDiagnosticPrescriptionDrawerFragment">;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
  };
};
export type useChUpdateNeuropsychologicDiagnosticPrescriptionMutation = {
  response: useChUpdateNeuropsychologicDiagnosticPrescriptionMutation$data;
  variables: useChUpdateNeuropsychologicDiagnosticPrescriptionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useChUpdateNeuropsychologicDiagnosticPrescriptionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_updateNeuropsychologicDiagnosticPrescriptionPayload",
        "kind": "LinkedField",
        "name": "ch_updateNeuropsychologicDiagnosticPrescription",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ch_NeuropsychologicDiagnosticPrescription",
            "kind": "LinkedField",
            "name": "ch_NeuropsychologicDiagnosticPrescription",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "chNeuropsychologicDiagnosticPrescriptionDrawerFragment"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useChUpdateNeuropsychologicDiagnosticPrescriptionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_updateNeuropsychologicDiagnosticPrescriptionPayload",
        "kind": "LinkedField",
        "name": "ch_updateNeuropsychologicDiagnosticPrescription",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ch_NeuropsychologicDiagnosticPrescription",
            "kind": "LinkedField",
            "name": "ch_NeuropsychologicDiagnosticPrescription",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "patientId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "progressNoteId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdBy",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "signedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "signedBy",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "language",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedBy",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sentAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sentBy",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "concludedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "concludedBy",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fileId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DocumentFileMetadata",
                "kind": "LinkedField",
                "name": "fileMetadata",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "documentType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "extension",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lengthInKilobytes",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "medicalPrescriptions",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "relationship",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phoneNumber",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "email",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "healthcareProviderId",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "0146c321bb946ad926bc9dcf6a4c09e6",
    "metadata": {},
    "name": "useChUpdateNeuropsychologicDiagnosticPrescriptionMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "eef868762a43ff91609d1892ea426b06";

export default node;
